<script setup lang="ts">
  import { useMpScreen } from '@borg/ui';

  const { breakpoints } = useMpScreen();
  const topActionsContainer = ref<HTMLElement | null>(null);
  const { y } = useElementBounding(topActionsContainer);
  const isVisible = computed(
    () => !!topActionsContainer.value && y.value < (breakpoints.isMd ? 50 : 35),
  );

  onMounted(() => {
    topActionsContainer.value = document.getElementById('job-actions');
  });
</script>

<template>
  <JobActionsBar :visible="isVisible">
    <ChooseApplicationTypeButton source="details_bottom" />
    <JobShareModal />
  </JobActionsBar>
</template>
